import TableRecord from "models/view-models/table-record";
import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface TableBasePathParams {
    annexId: number;
}

export interface TableQueryParams {}

const baseEndpoint = "publications/annexes/:annexId/tables";
const adminPreviewEndpoint = "admin/publications/annexes/:annexId/tables";

const resourceType = TableRecord;

const TableService = {
    list: ServiceFactory.nestedList<
        TableRecord,
        TableBasePathParams,
        TableQueryParams
    >(resourceType, baseEndpoint),
    useList: ServiceHookFactory.useNestedList<
        TableRecord,
        TableBasePathParams,
        TableQueryParams
    >(resourceType, baseEndpoint),
    usePreviewList: ServiceHookFactory.useNestedList<
        TableRecord,
        TableBasePathParams,
        TableQueryParams
    >(resourceType, adminPreviewEndpoint),
};

export default TableService;
